<template>
    <v-container style="max-width: 1240px" class="pb-5 pt-5">
        <v-content>
            <v-layout v-if="companiesList.length && !isErrorCalculate" class="pt-5">
                <v-flex>
                    <h2>Заявка одобрена</h2>
                    <p>Вы будете направлены на платежную страницу страховой, после чего полис отправится на почту, и
                        будет сохранен в Личном кабинете.</p>
                </v-flex>
            </v-layout>

            <v-layout v-else-if="isFormChanged && companiesList.length" class="pt-5">
                <v-flex>
                    <h2>Необходимо провести перерасчет полиса из-за измененных данных.</h2>
                </v-flex>
            </v-layout>

            <v-layout v-else-if="isErrorCalculate" class="pt-5">
                <v-flex>
                    <h2>Заявка не одобрена</h2>
                </v-flex>
            </v-layout>

            <!--            <v-layout v-else class="pt-5">
                            <v-flex>
                                <h2>Заявка не одобрена</h2>
                            </v-flex>
                        </v-layout>-->

            <v-layout
                v-for="(company, index) in sortedCompaniesList" :key="company.alias || index"
                wrap row align-center
                style="padding: 36px 0; border-bottom: 1px solid rgba(0, 0, 0, 0.2); border-top: 1px solid rgba(0, 0, 0, 0.2);"
            >
                <v-flex lg3 md3 xs8 sm3 pt-3 class="transit-list__logo">
                    <img
                        :src="company.image"
                        :alt="company.alias"
                        class="logo"
                    />
                </v-flex>
                <v-flex lg6 md6 sm8 pt-3 offset-xs1 xs3 offset-sm0 class="transit-list__data">
                    <v-layout row wrap>
                        <v-flex lg4 sm5 md5 class="transit-list__data__item hidden-xs-only" v-if="showCommission" style="align-self: flex-end">
                            <a v-show="!commissionsHidden"
                               @click="toggleCommissions"
                               class="color-black tip-icon width-auto"
                               data-tippy-animateFill="false"
                               data-tippy-animation="scale"
                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                            >
                                <label>Вознаграждение, Р</label>
                                <p v-if="company.payment && company.payment.commission_rub && company.payment.premium > 0">
                                    {{ company.payment.commission_rub > 0 ? Number(company.payment.commission_rub).toFixed(0) : '-' }}
                                </p>
                                <p v-else>
                                    -
                                </p>
                            </a>
                        </v-flex>
                        <v-flex lg4 sm5 md5 class="transit-list__data__item hidden-xs-only" v-if="showCommission" style="align-self: flex-end">
                            <a v-show="!commissionsHidden"
                               @click="toggleCommissions"
                               class="color-black tip-icon width-auto"
                               data-tippy-animateFill="false"
                               data-tippy-animation="scale"
                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                            >
                                <label>Вознаграждение, %</label>
                                <p v-if="company.payment && company.payment.commission && company.payment.premium > 0">
                                    {{ company.payment.commission > 0 ? Number(company.payment.commission).toFixed(0) : '-' }}
                                </p>
                                <p v-else>
                                    -
                                </p>
                            </a>
                            <a v-show="commissionsHidden"
                               @click="toggleCommissions"
                               class="color-black"
                               style="align-self: flex-start;"
                            >
                                <v-flex>
                                    Вернуть
                                </v-flex>
                            </a>
                        </v-flex>
                        <v-flex lg4 xs12 sm2 md2 class="transit-list__data__item hidden-xs-only price-item" style="align-self: flex-end">
                            <label>Цена, Р</label>
                            <p v-if="company.payment && company.payment.premium">
                                {{ company.payment.premium > 0 ? Number(company.payment.premium).toFixed(0) : '-' }}
                            </p>
                            <p v-else>
                                -
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="company.payment && company.payment.base">
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                            v-if="company.payment.base"
                        >
                            <label>Базовый тариф</label>
                            <p>
                                {{ company.payment.base > 0 ? Number(company.payment.base).toFixed(0) : '-' }}
                            </p>
                        </v-flex>
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                        >
                            <label>КТ</label>
                            <p>
                                {{ company.payment.kt > 0 ? Number(company.payment.kt) : '0' }}
                            </p>
                        </v-flex>
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                        >
                            <label>КБМ</label>
                            <p>
                                {{ company.payment.kbm > 0 ? Number(company.payment.kbm) : '0' }}
                            </p>
                        </v-flex>
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                        >
                            <label>КВС</label>
                            <p>
                                {{ company.payment.kvc > 0 ? Number(company.payment.kvc) : '0' }}
                            </p>
                        </v-flex>
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                        >
                            <label>КО</label>
                            <p>
                                {{ company.payment.ko > 0 ? Number(company.payment.ko) : '0' }}
                            </p>
                        </v-flex>
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                        >
                            <label>КС</label>
                            <p>
                                {{ company.payment.kc > 0 ? Number(company.payment.kc) : '0' }}
                            </p>
                        </v-flex>
                        <v-flex
                            shrink
                            class="transit-list__data__item hidden-xs-only price-item"
                            style="align-self: flex-end"
                        >
                            <label>КМ</label>
                            <p>
                                {{ company.payment.km > 0 ? Number(company.payment.km) : '0' }}
                            </p>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12 sm6 lg3 md3 layout column align-center class="transit-list__button-block">
                    <v-btn
                        class="button next-button block"
                        v-if="orderStatus && company.status !== 'error'"
                        :disabled="true"
                    >
                        <v-content v-if="company.payment.status === 'success'">
                            {{ 'Оформлен за ' + company.payment.premium + ' Р' }}
                        </v-content>

                        <v-content v-else-if="company.status !== 'error'">
                            {{ company.payment.premium + ' Р' }}
                        </v-content>
                    </v-btn>


                    <v-btn
                        class="button next-button block"
                        v-else-if="company.payment.status === 'success'"
                        :disabled="true"
                    >
                        <v-content>
                            {{ 'Оформлен за ' + company.payment.premium + ' Р' }}
                        </v-content>
                    </v-btn>
                    <v-btn
                        class="button next-button block"
                        v-else-if="isFormChanged"
                        @click="$emit('validate')"
                    >
                        <v-content>
                            {{ isFormChanged ? 'Проведите перерасчет' : company.payment.premium + ' Р' }}
                        </v-content>
                    </v-btn>
                    <v-btn
                        class="button next-button block"
                        @click="validateAndBuy(company)"
                        :loading="company.payment && company.payment.wait"
                        v-else-if="company.status !== 'error'"
                    >
                        <v-content>
                            {{ 'Оформить за ' + company.payment.premium + ' Р' }}
                        </v-content>
                    </v-btn>
                    <div v-else-if="company.status === 'error'">
                        <strong>Не подтверждено</strong>
                        <img class="tip-icon" src="/svg/q_red.svg" alt=""
                             data-tippy-animateFill="false"
                             data-tippy-animation="scale"
                             data-tippy-theme="red"
                             :data-tippy-content="company.error_message !== null ? company.error_message : 'Отказ в страховании'"
                        />
                    </div>
                </v-flex>
            </v-layout>
        </v-content>
    </v-container>
</template>

<script>
import ymMixin from "../../mixins/ym";
import _ from "lodash";

export default {
    name: 'TransitList',

    props: [
        'companiesList',
        'isFormChanged',
        'orderStatus',
        'validateAndBuy',
        'isErrorCalculate',
        'isSubmitButtonLoading',
    ],
    mixins: [ymMixin],

    data: () => ({
        showCommission: true,
        commissionsHidden: false,
        sortedCompaniesList: null,
    }),

    watch: {
        companiesList: {
            deep: true,
            immediate: true,
            handler: function () {
                const cloned = _.cloneDeep(this.companiesList);

                this.sortedCompaniesList = _.orderBy(
                    cloned,
                    [
                        // 1) Статус: успешные (нет status) -> 0, waiting -> 1, error -> 2
                        function (o) {
                            return o.status === 'ready' ? 0 : o.status === 'waiting' ? 1 : 2;
                        },
                        // 2) Premium (если нет — вниз)
                        function (o) {
                            if (o.payment && o.payment.premium) {
                                return Number(o.payment.premium);
                            }
                            return 1000000;
                        },

                        // 3) Alias по алфавиту
                        function (o) {
                            return o.alias ? o.alias.toLowerCase() : '';
                        }
                    ],
                    ['asc', 'asc', 'asc']
                );
            }
        }
    },

    methods: {
        toggleCommissions() {
            this.commissionsHidden = !this.commissionsHidden;
        },

        buy: function (company) {
            let that = this;

            const currentPath = window.location.pathname;
            const uuidFromPath = currentPath.split('/')[2];

            const makeRequest = (retryCount = 0) => {
                company.payment.wait = true;
                axios.get(`/api/transit/payment/${company.alias}/${uuidFromPath}`)
                    .then((response) => {
                        if (response.data.data.status === 400 && retryCount < 2) {
                            // Если статус 400, делаем задержку и повторяем запрос
                            setTimeout(() => makeRequest(retryCount + 1), 2000);
                        } else if (response.data.data.status !== 400) {
                            const paymentWindow = window.open(response.data.data.payment_link, '_blank');

                            const timer = setInterval(function () {
                                if (paymentWindow && paymentWindow.closed) {
                                    clearInterval(timer);
                                    that.paymentLoading = false;
                                }
                            }, 1000);
                        } else {
                            // Если после 3 попыток статус всё ещё 400
                            that.paymentLoading = false;
                            company.status = 'error';
                            if (response.data && response.data.data && response.data.data.error_message) {
                                company.error_text = 'Ссылка на оплату ещё не готова: ' + response.data.data.error_message;
                                PNotify.error(company.alias + '\n' + company.error_text);
                            } else {
                                company.error_text = 'Ссылка на оплату ещё не готова.';
                                PNotify.error(company.alias + '\n' + company.error_text);
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error.response);
                        that.paymentLoading = false;
                        company.status = 'error';
                        if (error.response && error.response.data.message) {
                            company.error_text = error.response.data.message;
                            PNotify.error(company.name + ":\n" + error.response.data.message);
                        }
                    })
                    .finally(() => {
                        company.payment.wait = false;
                    });
            };
            makeRequest();
        },
    },

    updated: function () {
        window.tippy.default('.tip-icon');
    },
}
</script>

<style scoped lang="scss">
.color-black {
    color: #000000;
}

.button {
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    width: 250px;
    height: 60px;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 10px 20px 0 0;

    border-width: 1px;
    border-radius: 100px;
    border-style: solid;
}

.button >>> .v-btn__content {
    white-space: normal;
    line-height: 1.1;
}

.next-button {
    color: #ffffff !important;
    background-color: #00ba57 !important;
    border-color: transparent;
}

.button {
    width: 270px;
    height: 56px;
    max-width: 100%;
    font-size: 18px !important;
    @media(max-width: 960px) {
        font-size: 16px !important;

        width: 250px;
        height: 50px;
    }
    @media(max-width: 600px) {
        font-size: 18px !important;

        width: 100%;
        height: 70px;
    }
}

.transit-list {
    &__logo {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            max-width: 226px;
            width: 100%;
            margin-bottom: 10px;
        }

        &__text {
            p {
                font-size: 14px;
            }
        }
    }

    &__data {
        &__more {
            // padding-top: 35px;
            padding-top: 20px;
            margin-bottom: 0;

            @media(max-width: 600px) {
                margin-bottom: 20px;
            }

            a {
                color: #000000;
                text-decoration: none;
                font-size: 16px !important;
                border-bottom: 1px solid #000000;

                &:hover, &:focus, &:active {
                    color: #000000;
                    text-decoration: none;
                }
            }

            .arrow-up-down {
                color: #000000;
                font-size: 20px;
                transition: transform .4s ease-in-out;
            }

            .rotate {
                transform: rotate(180deg);
            }
        }

        &__item {
            padding: 10px;

            label {
                font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
                font-size: 16px;
                color: #828282;
            }

            p {
                font-family: 'SFProBold', 'Arial', 'sans-serif';
                font-size: 28px;
                font-weight: 700;
                margin: 0;
                white-space: nowrap;
                @media (max-width: 1280px) {
                    font-size: 24px;
                }
            }
        }

        &__info {
            /*p {
                font-size: 16px;
                line-height: 19px;
                font-family: 'SFUIDisplay', 'SFPro', serif;


                .black-text {
                    color: #000000;
                    white-space: normal;

                    &__sum {
                        white-space: pre;
                    }
                }

                .bold-text {
                    font-family: 'SFProBold', 'SFUIDisplay', serif;
                    color: #000000;
                    line-height: 19px;
                }
            }*/

            &__title {
                font-family: 'SFProBold', 'SFUIDisplay', serif;
                font-size: 16px;
                color: #000000;
                line-height: 25px !important;
                margin-bottom: 10px;
            }

            &__subtitle {
                font-size: 16px;
                color: #828282;
                line-height: 19px;
                margin-bottom: 0;
            }

            &__subtext {
                font-family: 'SFUIDisplay', 'SFPro', serif;
                font-size: 16px;
                line-height: 19px;
                color: #000000;
                max-width: 350px;
                margin-bottom: 0;
            }

            &__docs {
                border: 1px solid #E8E8E8;
                border-radius: 28px;
                padding: 30px 30px;
            }

            a {
                font-family: 'SFUIDisplay', 'SFPro', serif;
                color: #00BA57;
                text-decoration: none;
                font-size: 15px !important;
                border-bottom: 1px solid #00BA57;

                &:hover, &:focus, &:active {
                    color: #00BA57;
                    text-decoration: none;
                }
            }

            .v-expansion-panel {
                box-shadow: none;
            }
        }
    }

    &__button-block {
        text-align: center;
        @media(max-width: 600px) {
            padding-top: 20px;
        }

        a {
            font-family: 'SFUIDisplay', 'SFPro', serif;
        }

        .mortgage-list__data__more {
            text-align: center;
            padding-top: 25px;
        }

        .button {
            // width: 100%;
            margin-right: 0;
            max-width: 100%;
            font-family: 'SFUIDisplay', 'SFPro', serif;

            .v-btn__content {
                max-width: 100%;
            }
        }

        .v-expansion-panel {
            padding-top: 15px;
            box-shadow: none;
            a {
                font-size: 14px;
                margin-bottom: 10px;
                line-height: 28px;
            }
        }

        .black-text {
            color: #000000;
            white-space: pre;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/transit-osago/TransitList.vue